import { Component, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { CompanyFormComponent } from '../company-form/company-form.component';
import { CompanyService } from '../../../services/companies/company.service';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-company-create',
  imports: [
    CompanyFormComponent,
    NgxSpinnerModule
  ],
  templateUrl: './company-create.component.html',
  styleUrl: './company-create.component.scss'
})
export class CompanyCreateComponent {
  @ViewChild(CompanyFormComponent) companyForm!: CompanyFormComponent;

  private router = inject(Router);
  private companyService = inject(CompanyService);
  private toast = inject(HotToastService);

  onSubmit() {
    const request = this.companyForm.getCreateRequest();
    if (!request) return;

    this.companyService.create(request).subscribe({
      next: (company) => {
        this.toast.success('Company created successfully');
        this.router.navigate(['/companies', 'edit', company.companyId]);
      },
      error: () => {
        this.toast.error('Failed to create company');
      }
    });
  }

  onCancel() {
    this.router.navigate(['/companies']);
  }
}
